/* eslint max-len: "off" */
import agriculturalLandSelected from '@propertypal/shared/src/resources/icons/filters/agricultural-land-icon-selected.svg?url';
import agriculturalLand from '@propertypal/shared/src/resources/icons/filters/agricultural-land-icon.svg?url';
import apartmentsSelected from '@propertypal/shared/src/resources/icons/filters/apartments-icon-selected.svg?url';
import apartments from '@propertypal/shared/src/resources/icons/filters/apartments-icon.svg?url';
import bungalowSelected from '@propertypal/shared/src/resources/icons/filters/bungalow-icon-selected.svg?url';
import bungalow from '@propertypal/shared/src/resources/icons/filters/bungalow-icon.svg?url';
import commercialSelected from '@propertypal/shared/src/resources/icons/filters/commercial-icon-selected.svg?url';
import commerical from '@propertypal/shared/src/resources/icons/filters/commercial-icon.svg?url';
import commercialLandSelected from '@propertypal/shared/src/resources/icons/filters/commercial-land-icon-selected.svg?url';
import commercialLand from '@propertypal/shared/src/resources/icons/filters/commercial-land-icon.svg?url';
import servicedOfficeSelected from '@propertypal/shared/src/resources/icons/filters/coworking-icon-selected.svg?url';
import servicedOffice from '@propertypal/shared/src/resources/icons/filters/coworking-icon.svg?url';
import farmDetachedSelected from '@propertypal/shared/src/resources/icons/filters/detached-farmhouses-icon-selected.svg?url';
import farmDetached from '@propertypal/shared/src/resources/icons/filters/detached-farmhouses-icon.svg?url';
import detachedSelected from '@propertypal/shared/src/resources/icons/filters/detached-icon-selected.svg?url';
import detached from '@propertypal/shared/src/resources/icons/filters/detached-icon.svg?url';
import farmBungalowSelected from '@propertypal/shared/src/resources/icons/filters/farmhouse-bungalows-icon-selected.svg?url';
import farmBungalow from '@propertypal/shared/src/resources/icons/filters/farmhouse-bungalows-icon.svg?url';
import genericSelected from '@propertypal/shared/src/resources/icons/filters/generic-residential-icon-selected.svg?url';
import generic from '@propertypal/shared/src/resources/icons/filters/generic-residential-icon.svg?url';
import hotelBBSelected from '@propertypal/shared/src/resources/icons/filters/hotel-icon-selected.svg?url';
import hotelBB from '@propertypal/shared/src/resources/icons/filters/hotel-icon.svg?url';
import housesSelected from '@propertypal/shared/src/resources/icons/filters/houses-icon-selected.svg?url';
import houses from '@propertypal/shared/src/resources/icons/filters/houses-icon.svg?url';
import IndependentLivingSelected from '@propertypal/shared/src/resources/icons/filters/independent-living-icon-selected.svg?url';
import IndependentLiving from '@propertypal/shared/src/resources/icons/filters/independent-living-icon.svg?url';
import industrialSelected from '@propertypal/shared/src/resources/icons/filters/industrial-icon-selected.svg?url';
import industrial from '@propertypal/shared/src/resources/icons/filters/industrial-icon.svg?url';
import industrialLandSelected from '@propertypal/shared/src/resources/icons/filters/industrial-land-icon-selected.svg?url';
import industrialLand from '@propertypal/shared/src/resources/icons/filters/industrial-land-icon.svg?url';
import businessSelected from '@propertypal/shared/src/resources/icons/filters/investment-icon-selected.svg?url';
import business from '@propertypal/shared/src/resources/icons/filters/investment-icon.svg?url';
import officeSelected from '@propertypal/shared/src/resources/icons/filters/office-icon-selected.svg?url';
import office from '@propertypal/shared/src/resources/icons/filters/office-icon.svg?url';
import parkingSelected from '@propertypal/shared/src/resources/icons/filters/parking-icon-selected.svg?url';
import parking from '@propertypal/shared/src/resources/icons/filters/parking-icon.svg?url';
import pubRestaurantSelected from '@propertypal/shared/src/resources/icons/filters/pub-restaurant-icon-selected.svg?url';
import pubRestaurant from '@propertypal/shared/src/resources/icons/filters/pub-restaurant-icon.svg?url';
import residentialLandSelected from '@propertypal/shared/src/resources/icons/filters/residential-land-icon-selected.svg?url';
import residentialLand from '@propertypal/shared/src/resources/icons/filters/residential-land-icon.svg?url';
import retailSelected from '@propertypal/shared/src/resources/icons/filters/retail-icon-selected.svg?url';
import retail from '@propertypal/shared/src/resources/icons/filters/retail-icon.svg?url';
import roomLetSelected from '@propertypal/shared/src/resources/icons/filters/room-lets-icon-selected.svg?url';
import roomLet from '@propertypal/shared/src/resources/icons/filters/room-lets-icon.svg?url';
import farmSemiDetachedSelected from '@propertypal/shared/src/resources/icons/filters/semi-detached-farmhouses-icon-selected.svg?url';
import farmSemiDetached from '@propertypal/shared/src/resources/icons/filters/semi-detached-farmhouses-icon.svg?url';
import semiDetachedSelected from '@propertypal/shared/src/resources/icons/filters/semi-detached-icon-selected.svg?url';
import semiDetached from '@propertypal/shared/src/resources/icons/filters/semi-detached-icon.svg?url';
import terracedSelected from '@propertypal/shared/src/resources/icons/filters/terraced-icon-selected.svg?url';
import terraced from '@propertypal/shared/src/resources/icons/filters/terraced-icon.svg?url';

import { ImgHTMLAttributes } from 'react';

interface StyleIcon {
  selected: ImgHTMLAttributes<any>;
  unselected: ImgHTMLAttributes<any>;
}

export const PROPERTY_STYLE_ICON_MAP: { [key: string]: StyleIcon } = {
  default: {
    selected: housesSelected,
    unselected: houses,
  },
  auctionsDefault: {
    selected: genericSelected,
    unselected: generic,
  },
  apartments: {
    selected: apartmentsSelected,
    unselected: apartments,
  },
  agriculturalDefault: {
    selected: genericSelected,
    unselected: generic,
  },
  agriculturalLand: {
    selected: agriculturalLandSelected,
    unselected: agriculturalLand,
  },
  bungalow: {
    selected: bungalowSelected,
    unselected: bungalow,
  },
  commercial: {
    selected: commercialSelected,
    unselected: commerical,
  },
  commercialDefault: {
    selected: genericSelected,
    unselected: generic,
  },
  commercialLand: {
    selected: commercialLandSelected,
    unselected: commercialLand,
  },
  detached: {
    selected: detachedSelected,
    unselected: detached,
  },
  farmDetached: {
    selected: farmDetachedSelected,
    unselected: farmDetached,
  },
  farmSemiDetached: {
    selected: farmSemiDetachedSelected,
    unselected: farmSemiDetached,
  },
  farmBungalow: {
    selected: farmBungalowSelected,
    unselected: farmBungalow,
  },
  hotelBB: {
    selected: hotelBBSelected,
    unselected: hotelBB,
  },
  houses: {
    selected: housesSelected,
    unselected: houses,
  },
  IndependentLiving: {
    selected: IndependentLivingSelected,
    unselected: IndependentLiving,
  },
  industrial: {
    selected: industrialSelected,
    unselected: industrial,
  },
  industrialLand: {
    selected: industrialLandSelected,
    unselected: industrialLand,
  },
  business: {
    selected: businessSelected,
    unselected: business,
  },
  office: {
    selected: officeSelected,
    unselected: office,
  },
  parking: {
    selected: parkingSelected,
    unselected: parking,
  },
  pubRestaurant: {
    selected: pubRestaurantSelected,
    unselected: pubRestaurant,
  },
  residentialDefault: {
    selected: genericSelected,
    unselected: generic,
  },
  residentialLand: {
    selected: residentialLandSelected,
    unselected: residentialLand,
  },
  retail: {
    selected: retailSelected,
    unselected: retail,
  },
  roomLet: {
    selected: roomLetSelected,
    unselected: roomLet,
  },
  servicedOffice: {
    selected: servicedOfficeSelected,
    unselected: servicedOffice,
  },
  semiDetached: {
    selected: semiDetachedSelected,
    unselected: semiDetached,
  },
  studentDefault: {
    selected: genericSelected,
    unselected: generic,
  },
  terraced: {
    selected: terracedSelected,
    unselected: terraced,
  },
};

export const getPropertyStyleIcon = (category: string, style: string, selected: boolean): ImgHTMLAttributes<any> => {
  let icon = PROPERTY_STYLE_ICON_MAP.default;

  if (PROPERTY_STYLE_ICON_MAP[style]) {
    icon = PROPERTY_STYLE_ICON_MAP[style];
  } else if (PROPERTY_STYLE_ICON_MAP[`${category}Default`]) {
    icon = PROPERTY_STYLE_ICON_MAP[`${category}Default`];
  }

  return selected ? icon.selected : icon.unselected;
};
